import { render } from "./DataCollectionForm.vue?vue&type=template&id=a57b2282&scoped=true"
import script from "./DataCollectionForm.vue?vue&type=script&lang=js"
export * from "./DataCollectionForm.vue?vue&type=script&lang=js"

import "./DataCollectionForm.vue?vue&type=style&index=0&id=a57b2282&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57b2282"]])

export default __exports__